var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9187 24.4387C15.6826 24.4387 18.7338 21.3849 18.7338 17.6178C18.7338 13.8507 15.6826 10.7969 11.9187 10.7969C8.15476 10.7969 5.10352 13.8507 5.10352 17.6178C5.10352 21.3849 8.15476 24.4387 11.9187 24.4387Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8819 24.4387C24.8457 24.4387 26.4376 21.3849 26.4376 17.6178C26.4376 13.8507 24.8457 10.7969 22.8819 10.7969C20.9181 10.7969 19.3262 13.8507 19.3262 17.6178C19.3262 21.3849 20.9181 24.4387 22.8819 24.4387Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2145 23.2528C28.8691 23.2528 29.3998 20.73 29.3998 17.6181C29.3998 14.5061 28.8691 11.9834 28.2145 11.9834C27.5599 11.9834 27.0293 14.5061 27.0293 17.6181C27.0293 20.73 27.5599 23.2528 28.2145 23.2528Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumDark);
export default __webpack_public_path__ + "static/media/mediumDark.36dafc7151d90749f70735a928403635.svg";
export { ForwardRef as ReactComponent };